import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../../state/actions";
import ReactTooltip from "react-tooltip";
import CheckboxField from "../../../shared/checkboxField/CheckboxField";
import LazyLoadImg from "../../../shared/lazyLoadImg/LazyLoadImg";
import InputField from "../../../shared/inputField/InputField";
import ModalConfirm from "../../../shared/modalConfirm/ModalConfirm";
import { gtmAddToCart, gtmRemoveFromCart } from "../../../../gtm/gtm";
import debounce from "../../../../utils/debounce";

const CartRow = ({
  idProdotto,
  nomeProdotto,
  codiceProdotto,
  titoloCategoria,
  dimensioni,
  unitaMisura,
  lunghezza,
  larghezza,
  profondita,
  metrilineari,
  diametro,
  prezzoFisso,
  isomaggio = null,
  prontaConsegna,
  giacenza,
  colore,
  opzioneId,
  opzioneName,
  peso,
  quantita,
  quantitaPrezzoFisso = null,
  imponibile,
  imponibileOriginale,
  flag_abilita_quantita_fissa = null,
  totale,
  totaleOriginale,
  immagine,
  isKit = false,
  isKitManodopera = false,
  isKitNotEmpty = false,
  kit_product_related_id = null,
  kit_product_cart_id = null,
  kit_data = null,
  isCheckedRows,
  onSelectRowFunction,
}) => {
  const dispatch = useDispatch();
  const currentPage = useSelector((state) => state.currentPage);
  const currentLang = useSelector((state) => state.currentPage.currentLang);
  const siteParams = useSelector((state) => state.siteParams);
  const order = useSelector((state) => state.order);
  const user = useSelector((state) => state.user);
  const tokenCarrello = useSelector((state) => state.user.token_id);
  const carrelloTranslation = useSelector(
    (state) => state.translations.carrello
  );
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const paginestaticheTranslation = useSelector(
    (state) => state.translations.paginestatiche
  );

  // local state
  const [quantity, setQuantity] = useState(quantita);

  useEffect(() => {
    console.log(
      prezzoProdotto,
      prezzoProdottoOriginale,
      quantitaPrezzoFisso,
      quantita
    );
  }, [isCheckedRows, quantita]);

  const onChangeQuantity = (event) => {
    //console.log(event);
    setQuantity(event.floatValue);
  };

  const onClickToChangeQuantity = (oldQuantity, newQuantity) => {
    // gtm remove from cart o add to cart (se aumento o diminuisco quantità)
    const productData = {
      titoloBreve: nomeProdotto,
      codice: codiceProdotto,
    };
    const categoryName = titoloCategoria;
    const prezzoProdotto = parseFloat(totale / quantita).toFixed(2);

    const diffQuantity = Math.abs(newQuantity - oldQuantity);
    console.log(newQuantity, oldQuantity, diffQuantity);
    const gtmSuffix = `gtm_code${currentLang}`;
    const currentGTMTAG = siteParams[gtmSuffix];
    if (newQuantity > oldQuantity) {
      // add to cart
      console.log("chiamo onClickToChangeQuantity");
      onGoToChangeQuantity();

      /* gtmAddToCart({
          productData,
          categoryName,
          prezzoCarrello: prezzoProdotto,
          quantitaCarrello: diffQuantity,
          callbackFunction: onGoToChangeQuantity,
          isGtmEnabled: currentGTMTAG !== null ? true : false,
        }); */
    } else {
      // remove from cart
      onGoToChangeQuantity();
      /* gtmRemoveFromCart({
          productData,
          categoryName,
          prezzoCarrello: prezzoProdotto,
          quantitaCarrello: diffQuantity,
          callbackFunction: onGoToChangeQuantity,
          isGtmEnabled: currentGTMTAG !== null ? true : false,
        }); */
    }
  };

  const onGoToChangeQuantity = () => {
    // chiamo action creator per aggiornare store
    console.log("chiamo updateCartQuantity", quantity);
    dispatch(
      allActions.cartDetailActions.updateCartQuantity(
        currentPage.currentLang,
        user?.userData?.id,
        order.selectedCountryRealId,
        tokenCarrello,
        idProdotto,
        quantity
      )
    );
  };

  const onAskUpdateCartItem = () => {
    ModalConfirm({
      titleToShow: carrelloTranslation.modalTitoloAggiornaQta.itemName,
      messageToShow: `${carrelloTranslation.modalConfermaAggiornaQta.itemName} <b>${quantity}</b>?`,
      textConfirmButton: genericheTranslation.conferma.itemName,
      textCancelButton: genericheTranslation.annulla.itemName,
      onClickHandler: () => onClickToChangeQuantity(quantita, quantity),
    });
  };

  const onSelectCartRow = (cart_id) => {
    setIsSelectedRow(!isSelectedRow);
    onSelectRowFunction(cart_id, isSelectedRow);
  };

  const onAskDeleteCartItem = (nomeProdotto) => {
    ModalConfirm({
      titleToShow: carrelloTranslation.modalTitoloRimozioneArticolo.itemName,
      messageToShow: `${carrelloTranslation.modalConfermaRimozioneArticolo.itemName} <b>${nomeProdotto}</b>?`,
      textConfirmButton: genericheTranslation.conferma.itemName,
      textCancelButton: genericheTranslation.annulla.itemName,
      onClickHandler: () => onDeleteCartItem(),
    });
  };

  const onDeleteCartItem = () => {
    // gtm remove from cart
    const productData = {
      titoloBreve: nomeProdotto,
      codice: codiceProdotto,
    };
    const categoryName = titoloCategoria;
    const prezzoProdotto = parseFloat(totale / quantita).toFixed(2);

    const gtmSuffix = `gtm_code${currentLang}`;
    const currentGTMTAG = siteParams[gtmSuffix];
    gtmRemoveFromCart({
      productData,
      categoryName,
      prezzoCarrello: prezzoProdotto,
      quantitaCarrello: quantita,
      callbackFunction: onGoToDeleteCartItem,
      isGtmEnabled: currentGTMTAG !== null ? true : false,
    });
  };

  const onGoToDeleteCartItem = () => {
    // chiamo action creator per aggiornare store
    dispatch(
      allActions.cartDetailActions.deleteCartItem(
        currentPage.currentLang,
        user?.userData?.id,
        order.selectedCountryRealId,
        tokenCarrello,
        idProdotto
      )
    );
  };

  const prezzoProdottoOriginale =
    imponibileOriginale > 0 ? (
      <span className="line-through font-opensanssemibold text-ribola-astral">
        {parseFloat(imponibileOriginale / (quantitaPrezzoFisso || 1))
          .toFixed(2)
          .toString()
          .replace(".", ",")}
        €
      </span>
    ) : (
      ""
    );

  const prezzoProdotto =
    imponibileOriginale > 0 ? (
      <span className="text-lg 3xl:text-xl text-ribola-amber font-opensansbold">
        {parseFloat(imponibile / (quantitaPrezzoFisso || 1))
          .toFixed(2)
          .toString()
          .replace(".", ",")}
        €
      </span>
    ) : (
      <span className="text-lg 3xl:text-xl text-ribola-astral font-opensansbold">
        {parseFloat(imponibile / (quantitaPrezzoFisso || 1))
          .toFixed(2)
          .toString()
          .replace(".", ",")}{" "}
        €
      </span>
    );

  const prezzoTotaleOriginale =
    totaleOriginale > 0 ? (
      <span className="line-through font-opensanssemibold text-ribola-astral">
        {parseFloat(totaleOriginale).toFixed(2).toString().replace(".", ",")} €
      </span>
    ) : (
      ""
    );

  const prezzoTotale =
    totaleOriginale > 0 ? (
      <span className="text-lg 3xl:text-xl text-ribola-amber font-opensansbold">
        {parseFloat(totale).toFixed(2).toString().replace(".", ",")} €
      </span>
    ) : (
      <span className="text-lg 3xl:text-xl text-ribola-astral font-opensansbold">
        {parseFloat(totale).toFixed(2).toString().replace(".", ",")} €
      </span>
    );

  const immagineCartArray = immagine?.split("/").filter((val) => val !== "");
  const immagineFormatted =
    immagineCartArray?.length > 0 ? (
      <LazyLoadImg
        imgName={immagineCartArray[2]}
        imgPath={immagineCartArray[0] + "/" + immagineCartArray[1]}
        imgWidth="59"
        imgHeight="59"
        imgStyle="flex-start"
        imgAlt={nomeProdotto}
      />
    ) : (
      ""
    );

  const divColore = colore ? (
    <span className="font-opensanssemibold text-sm">
      {genericheTranslation.colore.itemName}: {colore}
    </span>
  ) : (
    ""
  );

  const divOpzione =
    opzioneName && opzioneId != 0 ? (
      <span className="font-opensanssemibold text-sm">
        {genericheTranslation.opzione.itemName}: {opzioneName}
      </span>
    ) : (
      ""
    );

  let divMisure;
  if (lunghezza && larghezza && profondita) {
    divMisure = (
      <span className="font-opensanssemibold text-sm">
        {parseFloat(dimensioni).toFixed(2).toString().replace(".", ",")}
        &nbsp;
        {unitaMisura} (
        {parseFloat(lunghezza).toFixed(2).toString().replace(".", ",")}x
        {parseFloat(larghezza).toFixed(2).toString().replace(".", ",")}x
        {parseFloat(profondita).toFixed(2).toString().replace(".", ",")})
      </span>
    );
  } else if (lunghezza && larghezza) {
    divMisure = (
      <span className="font-opensanssemibold text-sm">
        {parseFloat(dimensioni).toFixed(2).toString().replace(".", ",")}
        &nbsp;
        {unitaMisura} (
        {parseFloat(lunghezza).toFixed(2).toString().replace(".", ",")}x
        {parseFloat(larghezza).toFixed(2).toString().replace(".", ",")})
      </span>
    );
  } else if (metrilineari) {
    divMisure = (
      <span className="font-opensanssemibold text-sm">
        {parseFloat(metrilineari).toFixed(2).toString().replace(".", ",")}
        &nbsp;
        {unitaMisura}
      </span>
    );
  } else if (diametro) {
    divMisure = (
      <span className="font-opensanssemibold text-sm">
        {parseFloat(diametro).toFixed(2).toString().replace(".", ",")}
        &nbsp;
        {genericheTranslation.metri.itemName}&nbsp; (
        {parseFloat(dimensioni).toFixed(2).toString().replace(".", ",")}&nbsp;
        {unitaMisura})
      </span>
    );
  } else {
    divMisure =
      quantita > 1 ? (
        <span className="font-opensanssemibold text-sm">
          {quantita} {genericheTranslation.pezzi.itemName}
        </span>
      ) : (
        <span className="font-opensanssemibold text-sm">
          {quantita} {genericheTranslation.pezzo.itemName}
        </span>
      );
  }

  // sovrascrivo divMisure nel caso di prodotto a prezzo fisso
  divMisure = prezzoFisso ? "" : divMisure;

  // pronta consegna?
  const showTagProntaConsegna = prontaConsegna ? (
    <span className="iconaTag bg-ribola-quicksand px-2 py-1 mt-2">
      {paginestaticheTranslation.titoloprontaconsegna.itemName}
    </span>
  ) : (
    ""
  );

  // stili e variabili custom per kit
  const showFullBorder =
    isKit === false && "border-b border-ribola-dove-gray border-opacity-20";
  const showBorderBottomKit =
    isKit && isKitNotEmpty && "border-b-3 border-ribola-quicksand pb-1";
  const titleKitMontaggio = isKit && isKitNotEmpty && (
    <span className="font-opensansbold text-black text-sm xl:text-base mt-8">
      {genericheTranslation.kitdimontaggio.itemName.toUpperCase()}
      <small className="text-xs text-ribola-quicksand ml-3">
        {kit_data?.name?.toUpperCase()}
      </small>
    </span>
  );
  const accessoryRowStyle =
    kit_product_related_id !== null
      ? "py-3"
      : isKit && isKitNotEmpty
      ? "pt-6"
      : "py-6";
  const selfStartImmagine = isKit && "self-start";
  const showImmagineProdotto = kit_product_related_id === null && (
    <div className={`w-14 h-14 mr-3 hidden xl:flex ${selfStartImmagine}`}>
      {immagineFormatted}
    </div>
  );
  const showImmagineProdottoAccessorio = kit_product_related_id !== null &&
    !isKitManodopera && (
      <div className="w-14 h-14 mr-3 hidden xl:flex">{immagineFormatted}</div>
    );
  const styleTextAccessori =
    kit_product_related_id === null
      ? "text-sm 3xl:text-base"
      : "text-sm text-ribola-quicksand";

  const quantitaKit = quantitaPrezzoFisso ? quantitaPrezzoFisso : quantita;

  // il nome della riga kit manodopera arriva dalle traduzioni, così segue lingua e modifiche dall'admin
  const nomeRiga =
    isKitManodopera && genericheTranslation.kitmanodopera?.itemName
      ? genericheTranslation.kitmanodopera.itemName
      : nomeProdotto;

  const hideFullBorder = !isKitManodopera && "border-none";
  const removePaddingTop = isKitManodopera && "pt-0";
  const removeMarginBottom = isKitManodopera ? "mb-0" : "mb-3";

  return (
    <div
      className={`grid grid-cols-60 text-ribola-tundora ${showFullBorder} ${hideFullBorder} ${removePaddingTop} ${accessoryRowStyle}`}
    >
      <div className="col-span-6 sm:col-span-3 flex justify-center items-center text-red-700">
        {isomaggio !== true && !isKitManodopera ? (
          <>
            <i
              className="far fa-times text-2xl cursor-pointer"
              data-tip={carrelloTranslation.tooltipCancellaArticolo.itemName}
              data-for={`${idProdotto}_cancellaSingolo`}
              onClick={() => onAskDeleteCartItem(nomeProdotto)}
            ></i>
            <ReactTooltip
              uuid={`${idProdotto}_cancellaSingolo`}
              id={`${idProdotto}_cancellaSingolo`}
              className="px-1 py-0.5 bg-black text-white"
            />
          </>
        ) : (
          <span className="flex justify-center">&nbsp;</span>
        )}
      </div>
      <div className="col-span-6 flex justify-between items-center">
        {!isKitManodopera ? (
          <>
            <CheckboxField
              checkboxType="checkbox"
              checkboxName="selectCartRow"
              isChecked={isCheckedRows}
              isFocus={false}
              isReadOnly={true}
              isDefaultChecked={false}
              checkboxLabelStyle="pointer-events-none"
              checkboxStyle="border-2 text-2xl text-ribola-dove-gray border-ribola-dove-gray pointer-events-none cursor-default opacity-40"
            />
            <ReactTooltip uuid={`${idProdotto}_selezionaSingolo`} />
            {showImmagineProdotto}
          </>
        ) : (
          <span></span>
        )}
      </div>
      <div
        className={`col-span-33 sm:col-span-36 xl:col-span-23 flex items-center ${showBorderBottomKit} pr-3`}
      >
        {showImmagineProdottoAccessorio}
        <div className="flex flex-col justify-center">
          <span
            className={`font-opensansbold flex flex-col items-start ${removeMarginBottom} ${styleTextAccessori}`}
          >
            {nomeRiga}
            {showTagProntaConsegna}
          </span>
          {!isKitManodopera ? divMisure : ""}
          {divColore}
          {divOpzione}
          <span className="font-opensanssemibold text-sm">
            {!isKitManodopera ? (
              <>
                {genericheTranslation.peso.itemName}:&nbsp;
                {parseFloat(peso).toFixed(2).toString().replace(".", ",")} kg
              </>
            ) : (
              <span></span>
            )}
          </span>
          <span className="font-opensanssemibold text-sm 3xl:text-base xl:hidden">
            Cod. {codiceProdotto}
          </span>
          {titleKitMontaggio}
        </div>
      </div>
      <div
        className={`col-span-7 items-center hidden xl:flex ${showBorderBottomKit}`}
      >
        <span className="font-opensanssemibold text-sm 3xl:text-base">
          {codiceProdotto}
        </span>
      </div>
      <div
        className={`col-span-15 xl:col-span-7 flex flex-col lg:flex-row lg:items-center ${showBorderBottomKit}`}
      >
        <div className="flex items-center">
          <div className="w-16 2xl:w-20">
            {isomaggio !== true &&
            prontaConsegna === false &&
            flag_abilita_quantita_fissa !== 1 ? (
              <InputField
                inputType="number"
                inputName="qta"
                inputValue={quantity}
                inputPlaceholder="1"
                inputStyle="border border-ribola-dove-gray mt-0"
                inputDecimalScale={0}
                inputDecimalSeparator={null}
                inputThousandSeparator={""}
                inputHandlerFunction={onChangeQuantity}
                inputMaxValue={999}
                inputMinValue={1}
                isNumberFormat={true}
                isAllowLeadingZero={false}
              />
            ) : (
              <span className="flex justify-center">{quantitaKit}</span>
            )}
          </div>
          {isomaggio !== true &&
            prontaConsegna === false &&
            flag_abilita_quantita_fissa !== 1 && (
              <span
                className="text-ribola-heavy-metal pr-3"
                onClick={onAskUpdateCartItem}
              >
                <i
                  className="far fa-sync-alt text-xl 2xl:text-2xl cursor-pointer ml-1 2xl:ml-3"
                  data-tip={carrelloTranslation.tooltipAggiornaQta.itemName}
                  data-for={`${idProdotto}_qta`}
                ></i>
                <ReactTooltip
                  uuid={`${idProdotto}_qta`}
                  id={`${idProdotto}_qta`}
                  className="px-1 py-0.5 bg-black text-white"
                />
              </span>
            )}
        </div>
        <span className="flex flex-col xl:hidden">
          {prezzoTotaleOriginale}
          {prezzoTotale}
        </span>
      </div>
      <div
        className={`col-span-7 flex-col justify-center hidden xl:flex ${showBorderBottomKit}`}
      >
        {prezzoProdottoOriginale}
        {prezzoProdotto}
      </div>
      <div
        className={`col-span-7 flex-col justify-center hidden xl:flex ${showBorderBottomKit}`}
      >
        {prezzoTotaleOriginale}
        {prezzoTotale}
      </div>
    </div>
  );
};

export default CartRow;
